// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__9Z4as"};